import api from "./api";
import http from "../reduxSaga/sagas/requests/http-common";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";
import getCurrentRefreshToken from "../reduxSaga/sagas/requests/currentRefreshToken";
class AuthService {
  login(login, password) {
    return api.post("/authenticate", { login, password });
  }

  changeForcedPassword(login, password, newPassword) {
    return api.post("/authenticate/changeForcedPassword", {
      login,
      password,
      newPassword,
    });
  }

  logout() {
    let currentUser = currentUserId();
    let currentRefreshToken = getCurrentRefreshToken();

    localStorage.removeItem("user");

    return api.put(`/logout/${currentRefreshToken}/${currentUser}`);
  }
  register(username, email, password) {
    return api.post("signup", { username, email, password });
  }

  // getAllBanks() {
  //   return api.get("/finance/Banque/getAllBanque");
  // }
  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }
}
export default new AuthService();
